import gql from 'graphql-tag';

export interface GqlCategory {
  id: string;
  name: string;
  canonicalName: string;
}

export const getCategory = gql`
query($id: ID!) {
  category(id: $id) {
    id
    name
    canonicalName
  }
}
`;

export interface GqlAttachment {
  id: string;
  small: string;
  large: string;
}

export interface GqlAuditor {
  id: string;
  name: string;
  avatar: {
    id: string;
    url: string;
  };
}

export interface GqlEntry {
  id: string;
  approvedAt: number | null;
  attachments: GqlAttachment[];
  auditor?: GqlAuditor;
  currPrice: number | null;
  lastPrice: number | null;
  maxPrice: number | null;
  minPrice: number | null;
  promoPrice: number | null;
  refPrice: number | null;
  noteAuditor: string | null;
  isOos: boolean | null;
  /** In-store promo? */
  isPromo: boolean | null;
  promotionTill: string | null;
  product: GqlProduct;
}

export interface GqlLastPrice {
  id: string;
  date: string;
  price: number;
}

export interface GqlOutlet {
  id: string;
  name: string;
  retailer: {
    id: string;
    logo: {
      id: string;
      url: string;
    };
  };
}

export interface GqlProduct {
  id: string;
  name: string;
  category?: {
    id: string;
    canonicalName: string;
  };
  lastPrice?: GqlLastPrice[];
  photo: {
    id: string;
    url: string;
  } | null;

}

export interface GqlTask {
  id: string;
  auditor: GqlAuditor;
  entries: GqlEntry[];
  outlet: GqlOutlet;
  priority: number;
}

export const getEntry = gql`
query($id: ID!, $outletId: ID!) {
  entry(id: $id) {
    id

    # prices
    currPrice
    lastPrice
    maxPrice
    minPrice
    promoPrice
    refPrice

    isPromo

    isOos

    noteAuditor

    promotionTill

    product {
      id
      name
      lastPrice(outlet: $outletId, last: 6) {
        id
        date
        price
      }
      photo {
        id
        url
      }
    }
  }
}
`;

export const getTasks = gql`
query($date: String!, $jobIds: [String], $outletIds: [String]) {
  tasks: listTask(date: $date, jobIds: $jobIds, outletIds: $outletIds) {
    id
    auditor {
      id
      name
      avatar {
        id
        url
      }
    }
    entries {
      id

      approvedAt
      attachments {
        id
        small
        large
      }

      # prices
      currPrice
      lastPrice
      maxPrice
      minPrice
      promoPrice
      refPrice

      noteAuditor

      isOos
      isPromo
      promotionTill

      product {
        id
        name
        photo {
          id
          url
        }
        category {
          canonicalName
        }
      }
    }
    outlet {
      id
      name
      retailer {
        id
        logo {
          id
          url
        }
      }
    }
    priority
  }
}
`;
